const rw = require('./rwJS');
/**
 * add metadate validator
 * @param elementName
 * @returns {boolean}
 * @param value
 */
function addValidatorMetaData( elementName, value ) {
    $.each($("*[name='" + elementName + "']"),function( index, obj ) {
        const validator = obj;
        let validators = $(validator).attr("data-validators");
        if (validators !== undefined ){
            validators = validators.split(",");
            if ( validators.filter( function(e) { return ( e === value );}).length === 0 ) {
                $(validator).attr("data-validators", $(validator).attr("data-validators") + "," + value );
            }
        } else {
            $(validator).attr("data-validators", value );
        }
        if ( $(".req" , $(validator).closest(".form-group")).length === 0 &&
            value === 'notempty' &&
            $(validator).closest(".form-group").children('label').text().length > 0 ) {
            const label= $(validator).closest(".form-group").children('label');
            label.html(label.html().trim() + "<i class='req'>*</i>");
        }
    });

    return true;
}

/**
 * add msg to an element error
 * @param elementName
 * @param value
 * @param message
 * @returns {boolean}
 */
function addErrorMetaData( elementName, value, message ) {
    $("*[name='" + elementName + "']").attr("data-message-" + value , message );

    return true;
}

/**
 * get msg to an element error
 * @returns {String}
 * @param validator
 * @param element
 */
function getErrorMetaData( validator,element ) {
    let message = $(element).attr("data-" + validator + "-message"  );
    if ( message === undefined || message.length === 0 ){
        message = "This element is not valid.";
    }

    return message;
}

/**
 * add metadata
 * @param elementName
 * @param value
 * @returns {boolean}
 * @param validator
 * @param metaName
 */
function addMetaData( validator, elementName, metaName, value ) {
    $("*[name='" + elementName + "']").attr("data-" + validator + "-" + metaName , value);

    return true;
}

/**
 * get metadata
 * @param elementName
 * @returns {String}
 * @param validator
 * @param metaName
 */
function getMetaData( validator, elementName, metaName ) {
    return $("*[name='" + elementName + "']").attr("data-" + validator + "-" + metaName );
}

/**
 * show element error
 * @param element
 * @param validator
 */
function showErrorMessage( validator, element) {
    rw.rwUtils.preventClick();
    const message = getErrorMetaData(validator, element);
    $(".invalid-feedback",$(element).closest(".form-group")).remove();
    $(element)
        .closest(".form-group")
        .children(".invalid-feedback")
        .remove();
    $(element)
        .parent()
        .children(".invalid-feedback")
        .remove();
    $(element)
        .addClass("is-invalid");
    if( $(element).hasClass('select2') ) {
        $(element).next('.select2-container').addClass('is-invalid');
    }
    $(element).parent().find('.invalid-feedback').remove();
    $(element)
        .parent()
        .append('<div class="invalid-feedback">' + message + '</div>');
    if( $(element).closest(".form-group").hasClass("other-lang-input") ) {
        $(element).closest(".form-group").css("height","inherit").slideDown();
    }
    const name = $(element).attr("data-name");
    $("input[data-name='" + name + "']").closest(".form-group").children("label").addClass("is-invalid");
}

/**
 * hide element error
 * @param element
 * @param validator
 */
function hideErrorMessage( validator, element) {
    $(element)
        .removeClass("invalid-feedback");
    $(element)
        .parent()
        .children(".invalid-feedback")
        .remove();
    $(element)
        .parent()
        .parent()
        .removeClass("is-invalid");
    $(element).closest(".form-group").removeClass("is-invalid");
    $(".invalid-feedback",$(element).closest(".form-group")).remove();
    $(".invalid-feedback",$(element).closest(".form-group")).remove();
    $(".is-invalid" , $($(element).closest(".form-group"))).removeClass("is-invalid")
    if ( $(element).closest(".form-group").hasClass("other-lang-input") ) {
        $(element).closest(".form-group").css("height","inherit");
    }
    const name = $(element).attr("data-name");
    $("input[data-name='" + name + "']").closest(".form-group").children("label").removeClass("is-invalid");
}

/**
 * Custom form submit event
 * @param elementName
 * @param value
 * @param msg
 * @returns {boolean}
 */
let pageValidate = true;
window.formValidation = function ( formName ) {
    $.each($('textarea.richtext'), function () {
        const $textarea = $(this);
        //first check ckeditor instance for prevent TypeError: "CKEDITOR.instances[$textarea.attr(...)] is undefined"
        if ( CKEDITOR.instances[$textarea.attr('id')] ) {
            $textarea.val(CKEDITOR.instances[$textarea.attr('id')].getData());
        }
    });
    pageValidate = true;
    if ( formName !== undefined ){
        $.each($("form[name='" + formName + "'] input," +
            "form[name='" + formName + "'] textarea," +
            "form[name='" + formName + "'] select," +
            "form[name='" + formName + "'] .select2-input"),function(index , input){
            if ( $(input).is(":visible") === true ||
                (
                    $(input).is(":visible") === false &&
                    $(input).hasClass('select2me') &&
                    $(input).parent().is(":visible")
                )
            ) {
                $(input).trigger("submitform");
            }
        });
    }
    if (!pageValidate){
        rw.rwUtils.flashMessage("danger","Please check invalid fields.",true );
        rw.rwUtils.removePreventClick();

        return false;
    }
    const form = $('form[name="' + formName + '"]');
    if ( form.data('processing') ) {
        let sendingMessage = 'Sending';
        if ( form.data("direction") === 'rtl' ) {
            sendingMessage = 'در حال ارسال';
        }
        form.find("button[type='submit']").addClass("placeholder placeholder-dots").prop("disabled", true);
        form.find("button[type='submit'] > span").text(sendingMessage).css("px-2");
        form.find("button[type='submit']").append(
            '<span class="dot"></span><span class="dot"></span><span class="dot"></span>'
        );
    }
    rw.rwUtils.preventClick();

    return pageValidate;
}

/**
 * Highlight tab when has error
 */
function highlightTabError() {
    $(".nav-tabs li a").removeClass('is-invalid');
    $.each($('.is-invalid'), function(){
        const tabId = $(this).closest(".tab-pane").attr('id');
        if( tabId !== undefined ) {
            $("a[href='#"+tabId+"']").addClass('is-invalid');
        }
    });
}
highlightTabError();

/**
 * form submit event
 * @param elementName
 * @param value
 * @param msg
 * @returns {boolean}
 */
$(document).on("submit","form", function() {
    $.each($('textarea.richtext'),function () {
        const $textarea =  $(this);
        $textarea.val(CKEDITOR.instances[$textarea.attr('id')].getData());
    });
    pageValidate = true;
    const that = $(this);
    let formName = $(this).attr("action");
    if ( formName !== undefined ) {
        $.each($("form[action='" + formName + "'] input,textarea,form[name='" + formName + "'] select,select2-input"),
            function(index , input) {
                if ($(input).attr("type") !== "hidden")
                    $(input).trigger("submitform");
            }
        );
    } else {
        formName = that.attr("name");
        $.each($("form[name='" + formName + "'] input,form[name='" + formName + "'] textarea,form[name='" + formName + "'] select,select2-input"),
            function(index , input){
                if ($(input).attr("type") !== "hidden")
                    $(input).trigger("submitform");
            }
        );
    }
    if (!pageValidate){
        rw.rwUtils.flashMessage("danger","Please check invalid fields.",true);
        rw.rwUtils.removePreventClick();

        return false;
    }
    return pageValidate;
});

/**
 * submitform event
 * @param elementName
 * @param params
 * @param msg
 * @returns {boolean}
 */
$(document).on( "submitform", "input,select,textarea", function () {
    const $this = $(this);
    let formValidat = true;
    const type_input = $this.attr('type');
    if( type_input === 'email' ) {
        $this.attr('type','text');
    }
    if (
        $this.is(":visible") ||
        $this.parents(".form-group").hasClass("other-lang-input") ||
        $this.hasClass('select2me')
    ) {
        $this.closest(".form-group")
            .children(".invalid-feedback")
            .remove();
        let this_val = $(this).val();
        let result = true;
        if ( $(this).attr("data-validators") === undefined ) {
            return true;
        }
        const validators = $this.attr("data-validators").split(",");
        let elementValidate = true;
        $.each( validators, function ( index, validator) {
            switch ( validator ) {
                case "boolean" :
                    result = validation_boolean(this_val);
                    break;
                case "file" :
                    result = validation_file($this);
                    break;
                case "integer" :
                    result = validation_integer(this_val);
                    break;
                case "ip" :
                    result = validation_ip(this_val);
                    break;
                case "ischecked" :
                    result = validation_isChecked($this);
                    break;
                case "slug" :
                    result = validation_slug(this_val);
                    break;
                case "notempty" :
                    if ( $this.attr("type") === 'radio' ) {
                        const name = $this.attr("name");
                        this_val = $("*[name='" + name + "']:checked").val();
                        if (this_val === undefined) {
                            this_val = "";
                        }
                    }
                    if( $this.prop("tagName") === 'SELECT' ) {

                        if ($this.val() === null) {
                            this_val = "";
                        }
                    }
                    result = validation_notempty(this_val);
                    break;
                case "email" :
                    result = validation_email(this_val);
                    break;
                case "string" :
                    result = validation_string($this);
                    break;
                case "url" :
                    result = validation_url(this_val);
                    break;
                case "date" :
                    result = validation_date($this);
                    break;
                case "time" :
                    result = validation_time(this_val);
                    break;
                case "numeric" :
                    result = validation_numeric(this_val);
                    break;
            }
            if ( !result ) {
                rw.rwUtils.removePreventClick();
                elementValidate = false;
                formValidat = false;
                showErrorMessage(validator, $this);
            } else if ( elementValidate ) {
                hideErrorMessage(validator, $this);
            }
        });
        if (!formValidat){
            rw.rwUtils.removePreventClick();
            pageValidate = formValidat;
        }
        highlightTabError();

        return pageValidate;
    } else {
        return true;
    }
});

/**
 * Set validator for element
 */
const pageValidators = [];
window.set_validator = function (validator, elementName, options) {
    if ( pageValidators.filter(
            function(e) {
                return  ( e.elementName === elementName && e.validator === validator );
            }
        ).length === 0
    ) {
        pageValidators.push({validator : validator , elementName : elementName , options : options});
    }
    addValidatorMetaData(elementName, validator);

    const i = Math.floor(( Math.random() * 100 ) + 1 );
    const formName = $("*[name='" + elementName + "']").closest("form").attr("data-v-id",i).attr('name');
    $('form[data-v-id="' + i + '"]').unbind("submit").bind("submit", function () {
        return formValidation( formName );
    });
    $.each(options, function ( meta, value ) {
        addMetaData( validator, elementName, meta, value );
    })

    return true;
}

/**
 * boolean validator
 */
function validation_boolean( input ) {
    const values = [1, 0, true, false, "on", "off", "yes", "no"];
    return $.inArray(input, values) > 0;
}

/**
 * file validator
 */
function validation_file( input ) {
    const elementName = input.attr("name");
    const fileName = input.val();
    /**
     * check file extension
     */
    const fileExten = (/[.]/.exec(fileName)) ? /[^.]+$/.exec(fileName) : undefined;
    if (fileExten !== undefined){
        return true;
    }
    if (getMetaData("file",elementName,"extension") !== undefined){
        const allowExtens = getMetaData("file",elementName,"extension").split(",");
        if ( $.inArray(fileExten[0], allowExtens) < 0 ) {
            return false ;
        }
    }
    /**
     * check Max_file size
     */
    const fileSize = input[0].files.length !== 0 ? input[0].files[0].size : 0;
    if ( getMetaData("file",elementName,"extension") !== undefined ) {
        const max_size = getMetaData("file",elementName,"max_size");
        if (fileSize >= max_size){
            return false;
        }
    }
    /**
     * check Min_file size
     */
    if ( getMetaData("file",elementName,"extension") !== undefined ) {
        const min_size = getMetaData("file",elementName,"min_size");

        return fileSize > min_size;
    }

    return true;
}

/**
 * notempty validator
 */
function validation_notempty( input ) {
    const filter = /([^\s])/;

    return filter.test(input);
}

/**
 * integer validator
 */
function validation_integer(input) {
    if ( input.trim() === "" ) {
        return true;
    }
    const filter = /^[0-9|-][0-9]*$/;

    return filter.test(input);
}

/**
 * IP validator
 */
function validation_ip( input ) {
    if ( input.trim() === '' ) {
        return true;
    }
    const filter = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;

    return filter.test(input);
}

/**
 * isChecked validator
 */
function validation_isChecked( input ) {
    return input.context.checked;
}

/**
 * slug validatios
 */
function validation_slug( input ) {
    if ( input.trim() === '' ) {
        return true;
    }
    const filter = /^[a-z]-?([a-z0-9]+(_|-)?)*[a-z0-9]$/;

    return filter.test(input);
}

/**
 * URL validator
 */
function validation_url( input )  {
    if ( input.trim() === '' ){
        return true;
    }
    let pattern = true;
    let filter = /^(ht|f)tps?:\/\/[a-z0-9-\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?$/;
    if ( !filter.test(input) ) {
        pattern =  false;
    }
    if ( !pattern ){
        filter = /^(ht|f)tps?:\/\/(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
        pattern = filter.test(input);
    }
    if ( !pattern ) {
        filter = /^(ht|f)tps?:\/\/(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}):(\d{1,5})$/;
        pattern = filter.test(input);
    }

    return pattern;
}

/**
 * email validatios
 */
function validation_email( input ) {
    if ( input.trim() === '' ) {
        return true;
    }
    const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    return filter.test(input);
}

/**
 * file validator
 */
function validation_string( input ) {
    const elementName = input.attr("name");
    const value = input.val();
    const value_lenght = value.length;
    const optional = getMetaData("string", elementName,"optional");
    if ( optional && !validation_notempty( value )  ){
        return true ;
    } else {
        /**
         * check min_length
         */
        const min_length = getMetaData("string", elementName,"min_length");
        if ( parseInt( min_length ) > 0 ) {
            if ( min_length >  value_lenght) {
                return false;
            }
        }
        /**
         * check max_length
         */
        const max_length = getMetaData("string", elementName,"max_length");
        if ( parseInt( max_length ) > 0 ) {
            if ( max_length <  value_lenght ) {
                return false;
            }
        }

        return true;
    }
}

/**
 * Date validator
 * Valid Format YYYY-MM-DD
 * @param input
 */
function validation_date( input ) {
    const format = $(input).attr("data-date-format");
    const value = $(input).val();
    let pattern = /^(\d{4})-((0[1-9])|(1[0-2]))-((0[1-9])|([1-2][0-9])|(3[0-1]))$/;
    switch ( format ) {
        case "yyyy-mm-dd":
            pattern = /^[0-9]{4}\-(0?[1-9]|1[0-2])\-(0?[1-9]|[1-2][0-9]|3[0-1])$/;
            break;
        case "dd-mm-yyyy":
            pattern = /^(0?[1-9]|[1-2][0-9]|3[0-1])\-(0?[1-9]|1[0-2])\-[0-9]{4}$/;
            break;
        case "mm-yyyy":
            pattern = /^(0?[1-9]|1[0-2])\-[0-9]{4}$/;
            break;
        case "yyyy":
            pattern = /^[0-9]{4}$/;
            break;
    }
    if( value !== '' ) {
        if( !value.match( pattern ) ) {
            return false;
        }
    }

    return true;
}

/**
 * Time validator
 * Valid Format ex 20:22 or 8:22pm
 * @param input
 */
function validation_time( input ) {
    const re = /^(((2[0-3]|[0-1][0-9]):[0-5][0-9])|(0?[1-9]|1[0-2]):[0-5][0-9](\s*)(a|p)m)$/;
    if( input !== '' ) {
        if( !input.match(re) )
        {
            return false;
        }
    }
    return true;
}

/**
 * Numeric validator
 * Valid Format ex -0.85, 1.85, 85 and ...
 * @param input
 */
function validation_numeric( input ) {
    if ( input.trim() === '' ) {
        return true;
    }

    return $.isNumeric(input);
}

/**
 * Clear validation for select element
 */
$("select").change( function() {
    $(this).closest(".form-group").removeClass("is-invalid");
    $(".invalid-feedback",$(this).closest(".form-group")).remove();
});